export default __webpack_public_path__ + "static/media/minus.7b55e32d.svg";